import React, { useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";
import { MdCloudUpload } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";

const FormTestimoni = ({ body, onChange }) => {
  const [uploading, setUploading] = useState(null);
  const [saving, setSaving] = useState(false);

  const [localData, setLocalData] = useState(
    body?.items ? body : { items: [] }
  );

  const update = (updatedData) => {
    setLocalData(updatedData);

    if (onChange) {
      onChange(updatedData);
    }
  };


  const setItem = (idx, field, value) => {
    const items = [...localData.items];

    items[idx] = {
      ...items[idx],
      [field]: value,
    };

    update({
      ...localData,
      items,
    });
  };


  const addItem = () => {
    const newItem = {
      name: "",
      role: "",
      content: "",
      avatar_url: "",
    };

    update({
      ...localData,
      items: [...localData.items, newItem],
    });
  };

  
  const removeItem = (idx) => {
    const items = localData.items.filter((_, i) => i !== idx);

    update({
      ...localData,
      items,
    });

    toast.success("Testimoni berhasil dihapus dari daftar");
  };

  /**

* Upload avatar
  */
  const handleUpload = async (idx, file) => {
    if (!file) return;

    setUploading(idx);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post("/api_w/upload/single", formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });

      let imageUrl = null;

      if (response.data?.data?.Location) {
        imageUrl = response.data.data.Location;
      } else if (response.data?.data?.url) {
        imageUrl = response.data.data.url;
      } else if (response.data?.data?.file) {
        imageUrl = response.data.data.file;
      } else if (response.data?.url) {
        imageUrl = response.data.url;
      } else if (response.data?.Location) {
        imageUrl = response.data.Location;
      } else if (response.data?.file) {
        imageUrl = response.data.file;
      } else if (typeof response.data === "string") {
        imageUrl = response.data;
      }

      if (!imageUrl) {
        toast.error("Gagal mendapatkan URL foto dari server");
        return;
      }

      if (!imageUrl.startsWith("http://") && !imageUrl.startsWith("https://")) {
        if (imageUrl.startsWith("/")) {
          imageUrl = `${window.location.origin}${imageUrl}`;
        } else {
          imageUrl = `https://${imageUrl}`;
        }
      }

      setItem(idx, "avatar_url", imageUrl);

      toast.success("Foto berhasil diunggah");
    } catch (error) {
      console.error("Upload error:", error);

      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Gagal mengupload foto"
      );
    } finally {
      setUploading(null);
    }
  };

  /**

* Pilih file
  */
  const handleFileChange = (idx, event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Ukuran file tidak boleh lebih dari 5MB");
      return;
    }

    if (!file.type.startsWith("image/")) {
      toast.error("File harus berupa gambar");
      return;
    }

    handleUpload(idx, file);
  };

  /**

* Simpan semua testimoni
  */
  const handleSave = async () => {
    if (localData.items.length === 0) {
      toast.warning("Tambahkan minimal satu testimoni");
      return;
    }

    const hasEmptyFields = localData.items.some(
      (item) =>
        !item.name?.trim() || !item.role?.trim() || !item.content?.trim()
    );

    if (hasEmptyFields) {
      toast.warning("Nama, role/jabatan, dan isi testimoni wajib diisi");
      return;
    }

    setSaving(true);

    try {
      /**
       * Simpan setiap testimoni satu per satu
       *
       * API:
       * POST /api_w/testimonials
       */
      for (const item of localData.items) {
        const payload = {
          name: item.name.trim(),
          role: item.role.trim(),
          content: item.content.trim(),
          avatar_url: item.avatar_url || null,
        };

        await axios.post("/api_w/testimonials", payload, {
          headers: {
            Authorization: localStorage.getItem("token"),
            db_name: process.env.REACT_APP_DB_NAME,
            "Content-Type": "application/json",
          },
        });
      }

      toast.success("Testimoni berhasil disimpan");

      /**
       * Reset form setelah berhasil disimpan
       */
      update({
        items: [],
      });
    } catch (error) {
      console.error("Save error:", error);

      toast.error(error.response?.data?.message || "Gagal menyimpan testimoni");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 p-6">
      {" "}
      <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
        {/* Header */}{" "}
        <div className="flex items-center justify-between border-b border-gray-200 px-8 py-6">
          {" "}
          <div>
            {" "}
            <h2 className="text-xl font-bold text-gray-900">Testimoni </h2>
            <p className="mt-1 text-sm text-gray-500">
              Tambahkan testimoni pengguna
            </p>
          </div>
          <button
            onClick={handleSave}
            disabled={saving || localData.items.length === 0}
            className="flex items-center gap-2 rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-semibold text-white shadow-md transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300"
          >
            <span>✓</span>

            {saving ? "Menyimpan..." : "Simpan"}
          </button>
        </div>
        {/* Content */}
        <div className="px-8 py-8">
          {/* List Testimoni */}
          <div className="mb-8 space-y-6">
            {localData.items.map((item, idx) => (
              <div
                key={idx}
                className="rounded-xl border border-gray-200 p-6 transition-shadow hover:shadow-md"
              >
                {/* Header Testimoni */}
                <div className="mb-6 flex items-center justify-between">
                  <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-400">
                    Testimoni {idx + 1}
                  </h3>

                  <button
                    type="button"
                    onClick={() => removeItem(idx)}
                    className="flex h-8 w-8 items-center justify-center rounded-lg bg-red-50 text-red-500 transition-colors hover:bg-red-100"
                    title="Hapus testimoni"
                  >
                    <FaTrash className="h-3.5 w-3.5" />
                  </button>
                </div>

                {/* Content */}
                <div className="grid grid-cols-1 gap-8 lg:grid-cols-4">
                  {/* Avatar */}
                  <div className="flex flex-col items-center lg:col-span-1">
                    <label className="mb-4 block text-xs font-semibold uppercase tracking-wide text-gray-600">
                      Foto
                    </label>

                    <label className="group relative flex h-32 w-32 cursor-pointer items-center justify-center overflow-hidden rounded-full border-2 border-dashed border-gray-300 bg-gray-50 transition-colors hover:border-blue-400 hover:bg-blue-50">
                      {item.avatar_url ? (
                        <>
                          <img
                            src={item.avatar_url}
                            alt={item.name || "Testimoni"}
                            className="h-full w-full object-cover transition-opacity group-hover:opacity-75"
                            onError={(event) => {
                              event.currentTarget.style.display = "none";
                            }}
                          />

                          <div className="bg-black/0 group-hover:bg-black/30 absolute inset-0 flex items-center justify-center transition-all">
                            <span className="text-xs font-semibold text-white opacity-0 transition-opacity group-hover:opacity-100">
                              Ganti
                            </span>
                          </div>
                        </>
                      ) : uploading === idx ? (
                        <div className="flex flex-col items-center gap-2">
                          <div className="border-r-transparent h-6 w-6 animate-spin rounded-full border-4 border-blue-500" />

                          <span className="text-xs text-gray-500">
                            Uploading...
                          </span>
                        </div>
                      ) : (
                        <div className="flex flex-col items-center gap-2">
                          <MdCloudUpload className="h-8 w-8 text-gray-400" />

                          <span className="text-xs text-gray-500">Upload</span>
                        </div>
                      )}

                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(event) => handleFileChange(idx, event)}
                        disabled={uploading === idx}
                      />
                    </label>
                  </div>

                  {/* Form */}
                  <div className="space-y-4 lg:col-span-3">
                    {/* Nama & Role */}
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                      <div>
                        <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-gray-600">
                          Nama
                        </label>

                        <input
                          type="text"
                          placeholder="Masukkan nama"
                          value={item.name || ""}
                          onChange={(event) =>
                            setItem(idx, "name", event.target.value)
                          }
                          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm outline-none transition-colors focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                        />
                      </div>

                      <div>
                        <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-gray-600">
                          Role / Jabatan
                        </label>

                        <input
                          type="text"
                          placeholder="Contoh: Guru, Siswa, Alumni"
                          value={item.role || ""}
                          onChange={(event) =>
                            setItem(idx, "role", event.target.value)
                          }
                          className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm outline-none transition-colors focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                        />
                      </div>
                    </div>

                    {/* Content */}
                    <div>
                      <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-gray-600">
                        Testimoni / Konten
                      </label>

                      <textarea
                        rows={4}
                        placeholder="Masukkan testimoni atau ulasan"
                        value={item.content || ""}
                        onChange={(event) =>
                          setItem(idx, "content", event.target.value)
                        }
                        className="w-full resize-none rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm outline-none transition-colors focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Empty State */}
          {localData.items.length === 0 && (
            <div className="flex w-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 py-16">
              <MdCloudUpload className="mb-4 h-16 w-16 text-gray-300" />

              <p className="mb-6 text-base font-medium text-gray-500">
                Belum ada testimoni
              </p>

              <button
                type="button"
                onClick={addItem}
                className="flex items-center gap-2 rounded-lg border-2 border-dashed border-gray-400 px-8 py-3 text-sm font-semibold text-gray-600 transition-colors hover:border-blue-500 hover:bg-blue-50 hover:text-blue-600"
              >
                <FaPlus className="h-4 w-4" />
                Tambah Testimoni
              </button>
            </div>
          )}

          {/* Add Button */}
          {localData.items.length > 0 && (
            <div className="flex justify-center">
              <button
                type="button"
                onClick={addItem}
                className="flex items-center gap-2 rounded-lg border-2 border-dashed border-gray-400 px-8 py-3 text-sm font-semibold text-gray-600 transition-colors hover:border-blue-500 hover:bg-blue-50 hover:text-blue-600"
              >
                <FaPlus className="h-4 w-4" />
                Tambah Testimoni
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormTestimoni;
